import { Box, Typography } from "@mui/material";
import { observer } from "mobx-react-lite";
import { CurlIcon } from "../../../../assets/common/icons/CurlIcon";
import { GoIcon } from "../../../../assets/common/icons/GoIcon";
import { JavaIcon } from "../../../../assets/common/icons/JavaIcon";
import { JavascriptIcon } from "../../../../assets/common/icons/JavascriptIcon";
import { NodejsIcon } from "../../../../assets/common/icons/NodejsIcon";
import { PythonIcon } from "../../../../assets/common/icons/PythonIcon";
import csharpIcon from "../../../../assets/common/icons/csharp-icon.svg";
import phpIcon from "../../../../assets/common/icons/php-icon.svg";
import BriaDropDown, { DropDownItem } from "../../BriaDropDown/BriaDropDown";
import styles from "./LanguagesDropdown.module.scss";

export type Language = "python" | "javascript" | "nodejs" | "curl" | "java" | "csharp" | "php" | "go";

const LanguagesDropdown = ({
	selectedLanguage,
	setSelectedLanguage,
}: {
	selectedLanguage: Language;
	setSelectedLanguage: (language: Language) => void;
}) => {
	const customLanguageItem = (language: Language, icon: React.ReactNode) => {
		return (
			<Box className={styles.dropdownItem}>
				<Box className={styles.dropdownValueContainer}>
					<Box className={styles.dropdownIconContainer}>{icon}</Box>
					<Typography className={styles.dropdownValue}>{language}</Typography>
				</Box>
			</Box>
		);
	};

	const languages: DropDownItem<Language>[] = [
		{
			key: "python",
			value: "python",
			customItem: customLanguageItem("python", <PythonIcon className={styles.dropdownIcon} />),
			customSelectedKey: customLanguageItem("python", <PythonIcon className={styles.dropdownIcon} />),
		},
		{
			key: "javascript",
			value: "javascript",
			customItem: customLanguageItem("javascript", <JavascriptIcon className={styles.dropdownIcon} />),
			customSelectedKey: customLanguageItem("javascript", <JavascriptIcon className={styles.dropdownIcon} />),
		},
		{
			key: "nodejs",
			value: "nodejs",
			customItem: customLanguageItem("nodejs", <NodejsIcon className={styles.dropdownIcon} />),
			customSelectedKey: customLanguageItem("nodejs", <NodejsIcon className={styles.dropdownIcon} />),
		},
		{
			key: "curl",
			value: "curl",
			customItem: customLanguageItem("curl", <CurlIcon className={styles.dropdownIcon} />),
			customSelectedKey: customLanguageItem("curl", <CurlIcon className={styles.dropdownIcon} />),
		},
		{
			key: "java",
			value: "java",
			customItem: customLanguageItem("java", <JavaIcon className={styles.dropdownIcon} />),
			customSelectedKey: customLanguageItem("java", <JavaIcon className={styles.dropdownIcon} />),
		},
		{
			key: "csharp",
			value: "csharp",
			customItem: customLanguageItem(
				"csharp",
				<img src={csharpIcon} alt="csharp" className={styles.dropdownIcon} />,
			),
			customSelectedKey: customLanguageItem(
				"csharp",
				<img src={csharpIcon} alt="csharp" className={styles.dropdownIcon} />,
			),
		},
		{
			key: "php",
			value: "php",
			customItem: customLanguageItem("php", <img src={phpIcon} alt="php" className={styles.dropdownIcon} />),
			customSelectedKey: customLanguageItem(
				"php",
				<img src={phpIcon} alt="php" className={styles.dropdownIcon} />,
			),
		},
		{
			key: "go",
			value: "go",
			customItem: customLanguageItem("go", <GoIcon className={styles.dropdownIcon} />),
			customSelectedKey: customLanguageItem("go", <GoIcon className={styles.dropdownIcon} />),
		},
	];
	return (
		<BriaDropDown<Language>
			items={languages}
			value={selectedLanguage}
			onChange={(e) => setSelectedLanguage(e.target.value as Language)}
			placeholder="Select language"
			componentsProps={{
				root: { className: styles.controlButton },
			}}
		/>
	);
};

export default observer(LanguagesDropdown);
